var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVideoGamePacmanEnemy = function SvgVideoGamePacmanEnemy(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.75C8.74264 15.75 9.75 14.0711 9.75 12C9.75 9.92893 8.74264 8.25 7.5 8.25C6.25736 8.25 5.25 9.92893 5.25 12C5.25 14.0711 6.25736 15.75 7.5 15.75Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15.75C16.2426 15.75 17.25 14.0711 17.25 12C17.25 9.92893 16.2426 8.25 15 8.25C13.7574 8.25 12.75 9.92893 12.75 12C12.75 14.0711 13.7574 15.75 15 15.75Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 10.5C2.25 7.91414 3.27723 5.43419 5.10571 3.60571C6.93419 1.77723 9.41414 0.75 12 0.75C14.5859 0.75 17.0658 1.77723 18.8943 3.60571C20.7228 5.43419 21.75 7.91414 21.75 10.5V19.5C21.75 21.571 20.407 23.25 18.75 23.25C17.093 23.25 15.75 21.571 15.75 19.5C15.75 20.4946 15.3549 21.4484 14.6517 22.1517C13.9484 22.8549 12.9946 23.25 12 23.25C11.0054 23.25 10.0516 22.8549 9.34835 22.1517C8.64509 21.4484 8.25 20.4946 8.25 19.5C8.25 21.571 6.907 23.25 5.25 23.25C3.593 23.25 2.25 21.571 2.25 19.5V10.5Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12.375C6.54289 12.375 6.375 12.2071 6.375 12C6.375 11.7929 6.54289 11.625 6.75 11.625",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12.375C6.95711 12.375 7.125 12.2071 7.125 12C7.125 11.7929 6.95711 11.625 6.75 11.625",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 12.375C14.0429 12.375 13.875 12.2071 13.875 12C13.875 11.7929 14.0429 11.625 14.25 11.625",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 12.375C14.4571 12.375 14.625 12.2071 14.625 12C14.625 11.7929 14.4571 11.625 14.25 11.625",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVideoGamePacmanEnemy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "video-game-pacman-enemy.7ac114b1d6fb61ddb2ccb49700b2e37c.svg";